export const ERROR_CODE = {
    wikiTokenInvalid: 301,
    uuapTokenInvalid: 401,
    accessTokenInvalid: 308,
    ugateTokenInvalid: 20801, // @ugate-todo 临时增加该错误码，增加 ugateToken 接口死循环调用问题; 后续兼容好后，记得把所以调用该参数的地方都去掉
};
